import styled from "styled-components";

export const NotificationButtonContainer = styled.div`
    position: relative;
    display: flex;
    height: min-content;
`;

export const DotBadge = styled.div`
    position: absolute;
    top: -1.5px;
    right: -1.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 6px;
    aspect-ratio: 1 / 1;
    background-color: ${props => props.theme.layouts.mainLayout.header.notifications.numberBadgeBgColor};
    border-radius: 50%;
`;
